import React, { useState, useEffect, useRef } from "react";
import "./DropDown.css";
import { CaretDown } from "phosphor-react";
import CategoryDropDown from "./CategoryDropDown";
import SizeDropDown from "./SizeDropDown";
import ColorDropDown from "./ColorDropDown";
import PriceDropDown from "./PriceDropDown";
import SortByDropDown from "./SortByDropDown";
import { Manager, Reference, Popper } from "react-popper";
import { clearCategory, clearSelectedColors, clearSelectedSizes, clearTags, resetMaxValue, resetMinValue, setSelectedSizes } from "../../appState/slices/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";

const dropdownComponents = {
  category: CategoryDropDown,
  size: SizeDropDown,
  color: ColorDropDown,
  price: PriceDropDown,
  "sort by": SortByDropDown,
};

function DropDown({ name }) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [selectedfilter, setSelectedFilter] = useState("");
  const dispatch = useDispatch();

  const updateSelectedFilter = (value) => {
    setSelectedFilter(value);
  }
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const handleDocumentClick = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setIsDropdownVisible(false);
    }
  };
  const minValue = useSelector((state) => state.product.minValue);
    const maxValue = useSelector((state) => state.product.maxValue);
  const clearfilter = () => {
    if(selectedfilter === "size"){
    dispatch(clearSelectedSizes());
    }
    else if(selectedfilter === "color"){
      dispatch(clearSelectedColors());
    }
    else if(selectedfilter === "price"){
      dispatch(resetMinValue(minValue));
      dispatch(resetMaxValue(maxValue));
    }
    else if(selectedfilter === "collection"){
      dispatch(clearCategory());
    }
    else if(selectedfilter === "category"){
      dispatch(clearTags());
    }
  }
  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener("mousedown", handleDocumentClick);
    } else {
      document.removeEventListener("mousedown", handleDocumentClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [isDropdownVisible]);

  const DropdownComponent = dropdownComponents[name];

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <button
            ref={ref}
            onClick={toggleDropdown}
            className="dropdown-btn"
          >
            {name} <CaretDown />
          </button>
        )}
      </Reference>
      {isDropdownVisible && (
        <Popper placement="bottom-start">
          {({ ref, style, placement }) => (
            <div
              ref={(node) => {
                ref(node);
                dropdownRef.current = node;
              }}
              style={{
                ...style,
                zIndex: 9999,
              }}
              data-placement={placement}
              className="dropdown-items isVisible"
            >
              {DropdownComponent && <DropdownComponent updateSelectedFilter={updateSelectedFilter} />}
              {name === "sort by" ?
                null
                :
                <div className="clearbtn" onClick={clearfilter}>Clear</div>
              }
            </div>
          )}
        </Popper>
      )}
    </Manager>
  );
}

export default DropDown;
